import React from 'react'
import GoogleViewer from './GoogleViewer'
import GoogleViewerById from './GoogleViewById'

const GooglePickerAPI = () => {
  return (
    <div>
      <GoogleViewer />
      <GoogleViewerById />
    </div>
  )
}
export default GooglePickerAPI
